// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Excel = function Excel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.375 17.5v-15c0-.344.281-.625.625-.625h6.25V5c0 .691.559 1.25 1.25 1.25h3.125V17.5a.627.627 0 0 1-.625.625H5a.627.627 0 0 1-.625-.625M5 0a2.5 2.5 0 0 0-2.5 2.5v15C2.5 18.879 3.621 20 5 20h10c1.379 0 2.5-1.121 2.5-2.5V6.035a2.5 2.5 0 0 0-.73-1.77L13.23.73A2.5 2.5 0 0 0 11.465 0zm3.55 9.113a.938.938 0 0 0-1.48 1.153L8.812 12.5l-1.738 2.238a.939.939 0 0 0 1.48 1.153L10 14.027l1.45 1.86a.938.938 0 0 0 1.48-1.153L11.188 12.5l1.738-2.238a.939.939 0 0 0-1.48-1.153L10 10.973z"
  }));
};
